import { useState, useEffect } from 'react'
import ApiAwards from '../api/ApiAwards'

export function useTrophyCase() {
  const [trophies, setTrophies] = useState([])
  const [bagTags, setBagTags] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    async function fetchAwards() {
      try {
        setLoading(true)
        const response = await ApiAwards.getMyAwards()

        if (response && response.success) {
          setTrophies(response.data?.trophies || [])
          setBagTags(response.data?.bagTags || [])
        } else {
          setTrophies([])
          setBagTags([])
        }
      } catch (err) {
        // Only log errors in development to avoid exposing implementation details
        if (process.env.NODE_ENV === 'development') {
          console.error('Error fetching trophy case:', err)
        }
        setError(err.message)
        setTrophies([])
        setBagTags([])
      } finally {
        setLoading(false)
      }
    }

    fetchAwards()
  }, [])

  return { trophies, bagTags, loading, error }
}
